import { NAVIGATION_TO_LANDING_PAGE } from '../../actions/page';
import {
  UPDATE_ENABLE_EMAIL,
  UPDATE_PRIMARY_EMAIL_ADDRESS,
  UPDATE_SECONDARY_EMAIL_ADDRESS,
  UPDATE_SECONDARY_EMAIL_SENT,
} from '../../actions/returnConfirmation';

export const initialState = {
  enableEmail: true,
  primaryEmail: '',
  secondaryEmail: '',
  secondaryEmailSent: false,
};

export default (
  state = initialState,
  { type, data: { enableEmail, primaryEmail, secondaryEmail, secondaryEmailSent } = {} } = {},
) => {
  switch (type) {
    case UPDATE_ENABLE_EMAIL:
      return {
        ...state,
        enableEmail,
      };

    case UPDATE_PRIMARY_EMAIL_ADDRESS:
      return {
        ...state,
        primaryEmail,
      };

    case UPDATE_SECONDARY_EMAIL_ADDRESS:
      return {
        ...state,
        secondaryEmail,
      };

    case UPDATE_SECONDARY_EMAIL_SENT:
      return {
        ...state,
        secondaryEmailSent,
      };

    case NAVIGATION_TO_LANDING_PAGE:
      return initialState;

    default:
      return state;
  }
};
